export default __webpack_public_path__ + "static/media/desktop_users.02e67231.svg";